import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconArrowUp = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0002 16.6665C13.0002 17.2188 12.5524 17.6665 12.0002 17.6665C11.4479 17.6665 11.0002 17.2188 11.0002 16.6665V9.74738L8.0406 12.7069C7.65008 13.0975 7.01691 13.0975 6.62639 12.7069C6.23586 12.3164 6.23586 11.6833 6.62639 11.2927L11.2931 6.62606C11.6836 6.23554 12.3167 6.23554 12.7073 6.62606L17.3739 11.2927C17.7645 11.6833 17.7645 12.3164 17.3739 12.7069C16.9834 13.0975 16.3502 13.0975 15.9597 12.7069L13.0002 9.74738V16.6665Z"
        />
      </svg>
    );
  }
);
